import { History, LocationState } from 'history';
import urlJoin from 'url-join';
import appConfig from 'src/appConfig';

let _history: History;

const setTopHistory = (history: History) => {
  _history = history;
};

const navigate = (routeName: string, state?: LocationState) => {
  _history.push(routeName, state);
};

const replace = (routeName: string, state?: LocationState) => {
  _history.replace(routeName, state);
};

const goBack = () => {
  var isCannotBack = _history.action === 'POP';
  isCannotBack ? _history.push(`/`) : _history.goBack();
};

const getNextPathInBaseUrl = (nextPath?: string) => {
  const baseURL = appConfig.WEB_URL as string;
  const path = nextPath || _history.location.pathname;
  const url = urlJoin(baseURL, path);

  return url;
};

const jumpToCrossDomain = (subDomain: string, nextPath?: string) => {
  const toUrl = getNextPathInBaseUrl(nextPath);
  const toCrossUrl = toUrl.replace('://', `://${subDomain}.`);
  window.location.href = toCrossUrl;
};

export default {
  setTopHistory,
  navigate,
  goBack,
  replace,
  jumpToCrossDomain,
};
